import {useSignalTelemetry} from '../context/SignalTelemetryContext'

export const useSignalGroupAlarms = (localNames: string[]) => {
  const {telemetryData} = useSignalTelemetry()

  if (!telemetryData) {
    return {
      alarms: 0,
      warnings: 0,
      modelBreaches: 0
    }
  }

  return localNames.reduce(
    (counts, localName) => {
      const data = telemetryData[localName]

      return {
        alarms: counts.alarms + (data?.threshold?.status === 'Alarm' ? 1 : 0),
        warnings: counts.warnings + (data?.threshold?.status === 'Warning' ? 1 : 0),
        modelBreaches: counts.modelBreaches + (data?.lastModelBreach ? 1 : 0)
      }
    },
    {alarms: 0, warnings: 0, modelBreaches: 0}
  )
}
